module.exports = __webpack_public_path__ + "static/img/swiper7.1eefd4bd.png";